import React                from 'react';
import { Observe }               from 'rewire-core';
import { WithStyle, withStyles } from 'rewire-ui';
import classNames                from 'classnames';
import { Theme }                 from '@material-ui/core/styles';
import CheckCircleIcon           from '@material-ui/icons/CheckCircle';
import ErrorIcon                 from '@material-ui/icons/Error';
import InfoIcon                  from '@material-ui/icons/Info';
import WarningIcon               from '@material-ui/icons/WarningRounded';
import { MessageLevel }          from '../DataTypes';

const styles = (theme: Theme) => ({
  listItemIcon: {
    minWidth: '36px',
  },
  icon: {
    fontSize: '16px',
  },
  success: {
    color: theme.palette.success.main
  },
  warning: {
    color: theme.palette.warning.main
  },
  error: {
    color: theme.palette.error.main
  },
  info: {
    color: theme.palette.info.main
  },
});

interface IMessageIconProps {
  level?:     MessageLevel;
  className?: string;
  classes?:   any;
  tooltip?:   string;
}

type MessageIconProps = WithStyle<ReturnType<typeof styles>, IMessageIconProps>;

class MessageIcon extends React.PureComponent<MessageIconProps> {
  constructor(props: MessageIconProps) {
    super(props);
  }

  getIcon(level: MessageLevel | undefined, classes: any, className?: string, tooltip?: string) {
    switch (level) {
      case 'success': return <CheckCircleIcon className={classNames(className, classes.icon, classes.success)} titleAccess={tooltip} />;
      case 'warning': return <WarningIcon     className={classNames(className, classes.icon, classes.warning)} titleAccess={tooltip} />;
      case 'error':   return <ErrorIcon       className={classNames(className, classes.icon, classes.error)}   titleAccess={tooltip} />;
      case 'info':    return <InfoIcon        className={classNames(className, classes.icon, classes.info)}    titleAccess={tooltip} />;
      default:        return null;
    }
  }

  render() {
    return <Observe render={() => {
      const { classes, className, level, tooltip } = this.props;
      return (
        this.getIcon(level, classes, className, tooltip)
      );
    }} />;
  }
}

export default withStyles(styles, MessageIcon);
